<div class="relative w-full h-screen flex flex-col items-center justify-center gap-6 px-6">

    <div class="absolute top-10 end-10 flex justify-center items-center 2xl:gap-5 gap-3.5">
      <div class="relative inline-block">
        <div (click)="toggleLanguageDropdown()"
          class="cursor-pointer text-[#1F1F1F] border-[#D1D1DB] border py-2 px-3 rounded-full 2xl:text-xs text-[0.6rem] font-light flex items-center gap-2 select-none"
        >
        {{ 'common.languages.' + languageService.currentLang() | translate }}
        <i class="bi bi-chevron-down 2xl:text-[0.6rem] text-[0.5rem] transition duration-300" [class.rotate-180]="isLanguageOpen"></i>
        </div>

        <div *ngIf="isLanguageOpen"
          class="w-24 absolute mt-2 -start-6 end-0 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden z-50"
        >
          <button (click)="changeLanguage('ar')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
            {{ 'common.languages.ar' | translate }}
            <img src="shared/navbar/ar_flag.png" alt="" class="w-3 h-3">
          </button>
          <button (click)="changeLanguage('en')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
            {{ 'common.languages.en' | translate }}
            <img src="shared/navbar/en_flag.png" alt="" class="w-3 h-3">
          </button>
        </div>
      </div>
    </div>

    <img src="/image/not-allowd.svg" alt="Not Allowed" class="w-full max-w-[420px]"/>

    <div class="flex flex-col items-center gap-2">
      <h1 class="text-2xl lg:text-3xl font-bold text-center text-[#404040]">
        {{ 'not_allowed.title' | translate }}
      </h1>

      <p class="text-lg lg:text-xl text-[#666666] text-center">
        {{ 'not_allowed.subtitle' | translate }}
      </p>

      <p class="lg:text-lg text-[#8C8C8C] text-center max-w-[650px]">
        {{ 'not_allowed.description' | translate }}
      </p>
    </div>

    <button (click)="logout()" class="mt-4 px-8 h-10 rounded-lg bg-[#611F79] text-white font-medium hover:opacity-90 transition cursor-pointer">
      {{ 'not_allowed.logout' | translate }}
    </button>

</div>
